import { useEffect } from "react";
import { UseFormReturn } from "react-hook-form";
import { FundingProfileFieldValues } from "../types";

export const usePersonalInfoFieldWatchers = (form: UseFormReturn<FundingProfileFieldValues>): void => {
  // Uppercase normalization watcher
  useEffect(() => {
    const subscription = form.watch((values) => {
      const v = values as FundingProfileFieldValues;

      // Normalize PAN to uppercase
      if (typeof v.pan === "string") {
        const upperPan = v.pan.toUpperCase();
        if (v.pan !== upperPan) {
          form.setValue("pan", upperPan, {
            shouldDirty: true,
            shouldTouch: true,
            shouldValidate: true,
          });
        }
      }

      // Normalize PID number to uppercase for CE, PEN_PAS, and COP_PAS types
      if (
        typeof v.pidNumber === "string" &&
        (v.pidType === "ce" || v.pidType === "pen_pas" || v.pidType === "cop_pas")
      ) {
        const upperPidNumber = v.pidNumber.toUpperCase();
        if (v.pidNumber !== upperPidNumber) {
          form.setValue("pidNumber", upperPidNumber, {
            shouldDirty: true,
            shouldTouch: true,
            shouldValidate: true,
          });
        }
      }
    });

    return () => subscription.unsubscribe();
  }, [form]);

  // PID type clearing watcher
  const pidType$ = form.watch("pidType");

  useEffect(() => {
    if (!!pidType$) {
      form.clearErrors("pidNumber");
      form.setValue("pidNumber", "", {
        shouldDirty: false,
        shouldTouch: false,
        shouldValidate: false,
      });
    }
  }, [pidType$, form]);
};
